(function () {
  // ── Konfiguration ─────────────────────────────────────────
  var API  = "https://cloud.lashesview.com/chatbot-b2c/chat";
  var FAQK = "https://cloud.lashesview.com/chatbot-b2c/faq/kategorien";
  var FAQF = "https://cloud.lashesview.com/chatbot-b2c/faq/fragen";
  var FAQL = "https://cloud.lashesview.com/chatbot-b2c/faq/log";
  var BWRT = "https://cloud.lashesview.com/chatbot-b2c/chat/bewertung";
  var KEY  = "00b5ac4e8a3b1e42";
  var LANG = "de";

  // Shopify Login-Status (wird von theme.liquid gesetzt)
  var LOGGED_IN = (typeof CUSTOMER_LOGGED_IN !== "undefined") ? CUSTOMER_LOGGED_IN : false;

  // Nur rendern wenn Container vorhanden
  var container = document.getElementById("beneganic-chat");
  if (!container) return;

   // ── Farben passend zu lashesview.at ──────────────────────
  var C = {
    primary:   "#f39578",   // Header-Farbe (Lachsrot)
    primary2:  "#f27a5a",   // Hover dunkler
    accent:    "#5E9C0D",   // Warenkorb-Button Grün
    dark:      "#1a1a1a",   // Standard Schriftfarbe
    bg:        "#f9a386",   // Template allgemein (hell)
    chatbg:    "#fdf6f3",   // Chat-Hintergrund (sehr hell)
    line:      "#f0e8e4",   // Linien
    white:     "#ffffff",
    userMsg:   "#f39578",   // User-Bubble
    botMsg:    "#ffffff",   // Bot-Bubble
  };


  // ── CSS ───────────────────────────────────────────────────
  var style = document.createElement("style");
  style.textContent = [
    "#beneganic-chat { max-width:700px; margin:20px 0 40px 0; font-family:Georgia,'Times New Roman',serif; border-radius:4px; overflow:hidden; box-shadow:0 2px 16px rgba(243,149,120,0.15); border:1px solid " + C.line + "; }",
    "#bc-head { background:" + C.primary + "; color:#fff; padding:14px 20px; display:flex; align-items:center; gap:10px; }",
    "#bc-head-icon { width:32px; height:32px; background:rgba(255,255,255,0.25); border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:16px; flex-shrink:0; }",
    "#bc-head-title { font-size:15px; font-weight:600; letter-spacing:.3px; }",
    "#bc-head-sub { font-size:12px; opacity:.85; font-style:italic; margin-top:1px; }",
    "#bc-login-hint { font-size:11px; opacity:.9; margin-top:3px; }",
    "#bc-login-hint a { color:#fff; text-decoration:underline; }",
    "#bc-msgs { height:420px; overflow-y:auto; padding:16px; background:" + C.chatbg + "; display:flex; flex-direction:column; gap:10px; border-left:1px solid " + C.line + "; border-right:1px solid " + C.line + "; }",
    "#bc-msgs::-webkit-scrollbar { width:4px; }",
    "#bc-msgs::-webkit-scrollbar-thumb { background:" + C.primary + "; border-radius:2px; }",
    ".bc-msg { max-width:82%; padding:10px 14px; font-size:14px; line-height:1.6; border-radius:3px; animation:bc-fade .25s ease; }",
    "@keyframes bc-fade { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }",
    ".bc-user { align-self:flex-end; background:" + C.primary + "; color:#fff; border-bottom-right-radius:0; }",
    ".bc-bot { align-self:flex-start; background:" + C.white + "; color:" + C.dark + "; border-bottom-left-radius:0; box-shadow:0 1px 4px rgba(0,0,0,0.07); border-left:3px solid " + C.primary + "; }",
    ".bc-typing { opacity:.7; font-style:italic; }",
    ".bc-kategorien { align-self:flex-start; max-width:100%; }",
    ".bc-kategorien p { font-size:13px; color:#888; margin:0 0 8px; font-style:italic; }",
    ".bc-kat-buttons { display:flex; flex-wrap:wrap; gap:8px; }",
    ".bc-kat-btn { padding:8px 16px; background:" + C.white + "; color:" + C.primary2 + "; border:1.5px solid " + C.primary + "; border-radius:2px; cursor:pointer; font-size:13px; font-family:inherit; transition:all .2s; }",
    ".bc-kat-btn:hover { background:" + C.primary + "; color:#fff; }",
    ".bc-fragen { align-self:flex-start; max-width:100%; width:100%; }",
    ".bc-fragen p { font-size:13px; color:#888; margin:0 0 8px; font-style:italic; }",
    ".bc-frage-btn { display:block; width:100%; text-align:left; padding:8px 14px; margin-bottom:6px; background:" + C.white + "; color:" + C.dark + "; border:1px solid " + C.line + "; border-left:3px solid " + C.primary + "; border-radius:2px; cursor:pointer; font-size:13px; font-family:inherit; transition:all .2s; }",
    ".bc-frage-btn:hover { background:" + C.chatbg + "; border-left-color:" + C.primary2 + "; }",
    ".bc-back-btn { padding:6px 12px; background:transparent; color:#999; border:1px solid #ddd; border-radius:2px; cursor:pointer; font-size:12px; font-family:inherit; margin-bottom:8px; }",
    ".bc-back-btn:hover { color:" + C.primary + "; border-color:" + C.primary + "; }",
    "#bc-foot { display:flex; gap:8px; padding:12px 14px; background:" + C.white + "; border:1px solid " + C.line + "; border-top:2px solid " + C.primary + "; }",
    "#bc-input { flex:1; padding:9px 14px; border:1px solid " + C.line + "; border-radius:2px; font-size:14px; font-family:inherit; color:" + C.dark + "; background:" + C.chatbg + "; outline:none; transition:border-color .2s; }",
    "#bc-input:focus { border-color:" + C.primary + "; background:#fff; }",
    "#bc-send { padding:9px 22px; background:" + C.primary + "; color:#fff; border:none; border-radius:2px; cursor:pointer; font-size:14px; font-family:inherit; transition:background .2s; }",
    "#bc-send:hover { background:" + C.primary2 + "; }",
    "#bc-send:disabled { background:#ccc; cursor:default; }",
    ".bc-hint { font-size:12px; color:#999; text-align:center; padding:6px 0 0; font-style:italic; }",
    ".bc-quellen { margin-top:8px; font-size:12px; color:#888; border-top:1px solid " + C.line + "; padding-top:6px; }",
    ".bc-quellen a { color:" + C.primary + "; text-decoration:none; font-style:italic; }",
    ".bc-quellen a:hover { text-decoration:underline; }",
    ".bc-lock { color:#aaa; font-style:italic; }",
    ".bc-lock a { color:" + C.primary + "; }",
    ".bc-bewertung { margin-top:8px; display:flex; gap:8px; align-items:center; }",
    ".bc-bw-btn { padding:4px 10px; border:1px solid #ddd; border-radius:12px; cursor:pointer; font-size:13px; background:#fff; transition:all .2s; }",
    ".bc-bw-btn:hover { border-color:" + C.primary + "; }",
    ".bc-bw-btn.positiv { background:#e8f5e9; border-color:" + C.green + "; }",
    ".bc-bw-btn.negativ { background:#ffebee; border-color:" + C.red + "; }",
    ".bc-bw-danke { font-size:12px; color:#888; font-style:italic; }",
  ].join("\n");
  document.head.appendChild(style);
 
  // ── HTML ──────────────────────────────────────────────────
  var loginHint = LOGGED_IN ? "" :
    '<div id="bc-login-hint">\uD83D\uDD12 <a href="/account/login">Einloggen</a> f\u00fcr Produkt- &amp; Quellenlinks</div>';
 
  container.innerHTML = [
    '<div id="bc-head">',
    '  <div id="bc-head-icon">&#128172;</div>',
    '  <div>',
    '    <div id="bc-head-title">LV Produktberatung</div>',
    '    <div id="bc-head-sub">Fragen Sie mich zu unseren Produkten &amp; Inhaltsstoffen '
    + '<a href="https://shop.lashesview.com/pages/lv-produktberatung-hilfe-zu-chat" target="_blank" '
    + 'style="color:rgba(255,255,255,0.8);font-size:11px;">\u2753 Hilfe</a></div>',
    loginHint,
    '  </div>',
    '</div>',
    '<div id="bc-msgs"></div>',
    '<div id="bc-foot">',
    '  <input id="bc-input" type="text" placeholder="Ihre eigene Frage..." autocomplete="off" />',
    '  <button id="bc-send">Senden</button>',
    '</div>',
    '<div class="bc-hint">Antworten basieren ausschlie&szlig;lich auf unseren Produktunterlagen.</div>',
  ].join("\n");
 
  var msgs  = document.getElementById("bc-msgs");
  var input = document.getElementById("bc-input");
  var send  = document.getElementById("bc-send");
 
  // ── XHR ───────────────────────────────────────────────────
  function xhr(method, url, headers, body, cb) {
    var r = new XMLHttpRequest();
    r.open(method, url, true);
    for (var h in headers) r.setRequestHeader(h, headers[h]);
    r.onreadystatechange = function () {
      if (r.readyState === 4) {
        try { cb(null, JSON.parse(r.responseText)); }
        catch (e) { cb(e, null); }
      }
    };
    r.onerror = function () { cb(new Error("Fehler"), null); };
    r.send(body || null);
  }
 
  // ── Nachricht hinzufügen ──────────────────────────────────
  function addMsg(text, type) {
    var d = document.createElement("div");
    d.className = "bc-msg bc-" + type;
    d.textContent = text;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
 
  // ── Quellen anzeigen ──────────────────────────────────────
  function zeigeQuellen(parentEl, quellen, loginRequired) {
    if (!quellen || !quellen.length) return;
    var qDiv = document.createElement("div");
    qDiv.className = "bc-quellen";
 
    if (loginRequired && !LOGGED_IN) {
      qDiv.innerHTML = '\uD83D\uDD12 <span class="bc-lock">'
        + '<a href="/account/login">Einloggen</a> f\u00fcr weitere Details</span>';
    } else {
      var links = [];
      quellen.forEach(function(item) {
        var label = "\uD83D\uDD17 Details";
        if (item.typ === "product") label = "\uD83D\uDED2 Zum Produkt";
        if (item.typ === "blog")    label = "\uD83D\uDCD6 Zum Artikel";
        if (item.typ === "page")    label = "\uD83D\uDCC4 Mehr Info";
        if (item.typ === "pdf")     label = "\uD83D\uDCC5 Download";
        if (item.url) {
          links.push('<a href="' + item.url + '" target="_blank">'
            + label + ': ' + item.name + '</a>');
        }
      });
      if (links.length) {
        qDiv.innerHTML = links.join("<br>");
      }
    }
    parentEl.appendChild(qDiv);
  }
 
  // ── Bewertungs-Buttons (nur für eingeloggte Kunden) ───────
  function zeigeBewerung(parentEl, frage, antwort) {
    if (!LOGGED_IN) return;  // ← nur für eingeloggte B2C Kunden
 
    var bwDiv = document.createElement("div");
    bwDiv.className = "bc-bewertung";
    bwDiv.innerHTML = '<span style="font-size:12px;color:#aaa;">War das hilfreich?</span>';
 
    var btnPos = document.createElement("button");
    btnPos.className = "bc-bw-btn";
    btnPos.textContent = "\uD83D\uDC4D";
    btnPos.title = "Hilfreich";
 
    var btnNeg = document.createElement("button");
    btnNeg.className = "bc-bw-btn";
    btnNeg.textContent = "\uD83D\uDC4E";
    btnNeg.title = "Nicht hilfreich";
 
    function sendBewertung(wert) {
      btnPos.disabled = true;
      btnNeg.disabled = true;
      if (wert === "positiv") btnPos.classList.add("positiv");
      else btnNeg.classList.add("negativ");
      bwDiv.innerHTML = '<span class="bc-bw-danke">Danke f\u00fcr Ihr Feedback! '
        + (wert === "positiv" ? "\uD83D\uDE0A" : "\uD83D\uDCDD notiert") + '</span>';
      xhr("POST", BWRT,
        {"Content-Type": "application/json", "X-Api-Key": KEY},
        JSON.stringify({frage: frage, antwort: antwort, bewertung: wert}),
        function() {}
      );
    }
 
    btnPos.onclick = function() { sendBewertung("positiv"); };
    btnNeg.onclick = function() { sendBewertung("negativ"); };
    bwDiv.appendChild(btnPos);
    bwDiv.appendChild(btnNeg);
    parentEl.appendChild(bwDiv);
  }
 
  // ── FAQ-Klick loggen ──────────────────────────────────────
  function logFaqKlick(frage) {
    xhr("POST", FAQL,
      {"Content-Type": "application/json", "X-Api-Key": KEY},
      JSON.stringify({frage: frage}),
      function() {}
    );
  }
 
  // ── Kategorien anzeigen ───────────────────────────────────
  function zeigeKategorien() {
    xhr("GET", FAQK, {"X-Api-Key": KEY}, null, function(err, data) {
      var div = document.createElement("div");
      div.className = "bc-kategorien";
      if (err || !data || !data.kategorien || !data.kategorien.length) {
        div.innerHTML = '<p>Keine Kategorien verf\u00fcgbar.</p>';
        msgs.appendChild(div);
        return;
      }
      var html = '<p>Bitte w\u00e4hlen Sie ein Thema:</p><div class="bc-kat-buttons">';
      data.kategorien.forEach(function(kat) {
        html += '<button class="bc-kat-btn" data-kat="' + kat + '">' + kat + '</button>';
      });
      html += '</div>';
      div.innerHTML = html;
      msgs.appendChild(div);
      msgs.scrollTop = msgs.scrollHeight;
 
      div.querySelectorAll(".bc-kat-btn").forEach(function(btn) {
        btn.onclick = function() {
          var kat = this.getAttribute("data-kat");
          addMsg(kat, "user");
          msgs.removeChild(div);
          zeigeFragen(kat);
        };
      });
    });
  }
 
  // ── Fragen anzeigen ───────────────────────────────────────
  function zeigeFragen(kategorie) {
    var thinking = addMsg("\u23f3 Lade Fragen...", "bot");
    thinking.classList.add("bc-typing");
 
    xhr("GET", FAQF + "?kategorie=" + encodeURIComponent(kategorie),
      {"X-Api-Key": KEY}, null, function(err, data) {
        msgs.removeChild(thinking);
        if (err || !data || !data.fragen || !data.fragen.length) {
          addMsg("Keine Fragen gefunden.", "bot");
          return;
        }
        var div = document.createElement("div");
        div.className = "bc-fragen";
        var html = '<button class="bc-back-btn" id="bc-back">\u2190 Zur\u00fcck zur Auswahl</button>';
        html += '<p>H\u00e4ufige Fragen zu <strong>' + kategorie + '</strong>:</p>';
        data.fragen.forEach(function(item) {
          html += '<button class="bc-frage-btn" data-antwort="' +
            item.antwort.replace(/"/g, "&quot;").replace(/'/g, "&#39;") +
            '">' + item.frage + '</button>';
        });
        div.innerHTML = html;
        msgs.appendChild(div);
        msgs.scrollTop = msgs.scrollHeight;
 
        div.querySelector("#bc-back").onclick = function() {
          msgs.removeChild(div);
          addMsg("Was m\u00f6chten Sie wissen?", "bot");
          zeigeKategorien();
        };
 
        div.querySelectorAll(".bc-frage-btn").forEach(function(btn) {
          btn.onclick = function() {
            var frage   = this.textContent;
            var antwort = this.getAttribute("data-antwort");
            msgs.removeChild(div);
            addMsg(frage, "user");
            var resp = addMsg(antwort, "bot");
            resp.style.maxWidth = "95%";
            logFaqKlick(frage);
            msgs.scrollTop = msgs.scrollHeight;
            setTimeout(function() {
              addMsg("Haben Sie weitere Fragen?", "bot");
              zeigeKategorien();
            }, 800);
          };
        });
      });
  }
 
  // ── Freie Frage ───────────────────────────────────────────
  function sendMsg() {
    var q = input.value.trim();
    if (!q || send.disabled) return;
    input.value = "";
    send.disabled = true;
    addMsg(q, "user");
    var thinking = addMsg("\u23f3 Einen Moment bitte\u2026", "bot");
    thinking.classList.add("bc-typing");
 
    xhr("POST", API,
      {"Content-Type": "application/json", "X-Api-Key": KEY},
      JSON.stringify({
        message: q,
        language: LANG,
        customer_logged_in: LOGGED_IN
      }),
      function(err, data) {
        var istFehler = err || !data ||
          (data.answer && data.answer.indexOf("nicht verf\u00fcgbar") !== -1);
 
        var antwort = istFehler
          ? "Verbindungsfehler \u2013 bitte sp\u00e4ter nochmal versuchen."
          : (data.answer || "Keine Antwort erhalten.");
 
        thinking.textContent = antwort;
        thinking.classList.remove("bc-typing");
 
        // Quellen nur bei gültiger Antwort UND eingeloggt:
        if (!istFehler && data && data.quellen && data.quellen.length > 0) {
          zeigeQuellen(thinking, data.quellen, data.login_required);
        } else if (!istFehler && data && data.login_required) {
          // Nicht eingeloggt – Login-Hinweis anzeigen:
          zeigeQuellen(thinking, data.quellen, true);
        }
 
        // Bewertung nur für eingeloggte Kunden und bei gültiger Antwort:
        if (!istFehler) {
          zeigeBewerung(thinking, q, antwort);
        }
 
        send.disabled = false;
        input.focus();
        msgs.scrollTop = msgs.scrollHeight;
        setTimeout(function() {
          addMsg("Weitere Fragen?", "bot");
          zeigeKategorien();
        }, 1000);
      });
  }
 
  send.onclick = sendMsg;
  input.onkeydown = function(e) { if (e.key === "Enter") sendMsg(); };
 
  // ── Start ─────────────────────────────────────────────────
  setTimeout(function() {
    addMsg("Hallo! \uD83D\uDC4B Willkommen bei der LV Produktberatung. W\u00e4hlen Sie ein Thema oder stellen Sie Ihre Frage direkt ein.", "bot");
    zeigeKategorien();
  }, 300);
 
})();
